import { useState, memo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Spinner from '../../common/Spinner';
import styles from './TrendingPanel.module.css';

const Sparkline = memo(({ data }) => {
  if (!data?.length) return null;
  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={{
        chart: { type: 'line', width: 80, height: 40, margin: [0, 0, 0, 0], backgroundColor: 'transparent' },
        title: { text: undefined },
        xAxis: { visible: false },
        yAxis: { visible: false },
        legend: { enabled: false },
        tooltip: { enabled: false },
        credits: { enabled: false },
        plotOptions: { line: { marker: { enabled: false }, lineWidth: 1.5, color: '#4a90e2', enableMouseTracking: false } },
        series: [{ data: data.map(p => p[1]) }],
      }}
    />
  );
});

const TrendingPanel = ({ items = [], onSelect, loading }) => {
  const [open, setOpen] = useState(false);

  if (!loading && items.length === 0) return null;

  return (
    <div className={styles.panel}>
      <button className={styles.header} onClick={() => setOpen(o => !o)}>
        <span className={`${styles.chevron} ${open ? styles.chevronOpen : ''}`}>▶</span>
        Trending
      </button>
      {open && (
        loading ? (
          <div className={styles.loading}><Spinner size="sm" label="Loading…" /></div>
        ) : (
          <div className={styles.body}>
            {items.map((item, i) => (
              <div
                key={item.symbol}
                className={styles.card}
                onClick={() => onSelect(item.symbol)}
                role="button"
                tabIndex={0}
                onKeyDown={e => e.key === 'Enter' && onSelect(item.symbol)}
              >
                <div className={styles.cardTop}>
                  <span className={styles.rank}>#{i + 1}</span>
                  {/* Ticker with the company name trailing it, right-aligned.
                      The name is intentionally very small and truncated so a
                      long name (e.g. "Taiwan Semiconductor Manufacturing")
                      can't blow out the fixed-width card. Absent when the
                      backend has no name yet (see trending/index.mjs) — the
                      ticker then stands alone. */}
                  <span className={styles.identity}>
                    <span className={styles.symbol}>{item.symbol}</span>
                    {item.name && (
                      <span className={styles.name} title={item.name}>{item.name}</span>
                    )}
                  </span>
                </div>
                <Sparkline data={item.prices} />
              </div>
            ))}
          </div>
        )
      )}
    </div>
  );
};

export default TrendingPanel;
